var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Arrow = /** @class */ (function (_super) {
    __extends(Arrow, _super);
    function Arrow(props) {
        var _this = _super.call(this, props) || this;
        _this.baseClass = "rj-arrow";
        _this.holderClass = _this.baseClass + "__holder";
        return _this;
    }
    Arrow.prototype.render = function () {
        var fullClass = this.holderClass + (this.props.direction ?
            " " + this.holderClass + "--" + this.props.direction :
            "");
        return (React.createElement("span", { className: this.baseClass },
            React.createElement("span", { className: fullClass })));
    };
    return Arrow;
}(React.PureComponent));
export { Arrow };
//# sourceMappingURL=Arrow.js.map